(function() {
    'use strict';
    var controllerId = 'ProductParentListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$routeParams', 'NgTableParams', ProductParentListCtrl]);
    function ProductParentListCtrl(common, datacontext, $scope, $location, $routeParams, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');

        var vm = this;
        vm.startSearch = 0;
        vm.title = 'Parent List View';
        if(angular.isDefined($routeParams.MParID)){
          var m_parent_id = $routeParams.MParID;
        }else{
          var m_parent_id = '';
        }
        vm.query = {
            queryType:'array-count',
            search:'',
            search_asin:'',
            product_title:'',
            parent_status_id:'',
            relationship_status_id:'',
            user_audit_status:'',
            master_parent_id:'',
            m_parent_id:m_parent_id,
            theme_prefix:'',
            parent_theme:'',
            rollup_count:'2+',
            parents_not_in_rollup:0,
            page:1,
            limit:50
        };

        vm.setCalendarValues = function() {
            vm.query.category_id = 21;
            vm.query.m_title = '2025';
            vm.query.rollup_count = '';
        }
        vm.searchProductTitle = function() {
                vm.query.rollup_count = '0';
                vm.query.page = 1;
                get_product_parent();
            };

        vm.showParentsNotInRollup = function() {
            vm.query.product_title = '';
            vm.query.master_parent_id = '';
            vm.query.rollup_count = 0;
            vm.query.parents_not_in_rollup = 1;
            vm.query.page = 1;
        };

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            vm[i] = vm.urlQuery[i];
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            if (newValue.product_title !== oldValue.product_title) {
                if (newValue.product_title && newValue.product_title.trim() !== '') {
                    vm.query.rollup_count = '0';
                }
            }

            if (newValue.master_parent_id !== oldValue.master_parent_id) {
                vm.query.product_title = '';
                if (newValue.master_parent_id === '0') {
                    vm.query.rollup_count = '0';
                } else {
                    vm.query.rollup_count = '2+';
                }
            }

            for ( var i in newValue ) {
            	if ( i !== 'page' && i !== 'product_title' && newValue[i] !== oldValue[i]) {
                     console.log(i, newValue[i], oldValue[i]);
                     vm.startSearch ++;

                     if( oldValue[i] >= 0 || oldValue[i] == "" || oldValue[i] < 0 || angular.isUndefined(oldValue[i])  == true || newValue[i] !== oldValue[i]){

                    	 get_product_parent();
                     }else{
                    	 console.log(oldValue[i]+'---'+angular.isUndefined(oldValue[i]));
                         return "";
                     }
                 }

                /*if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_product_parent();
                } */
            }
            vm.grid = 0;
        });

        activate();

        function activate() {
            var promises = [
                get_product_parent(),
                getProductCategories(),
                get_stores(),
                get_missing_title_parents(),
                get_color_variation_issue_parents(),
                get_aws_variation_themes()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Product List View');
                });
        }

        function get_stores() {
            return datacontext.get_stores({marketplace_id:1}).then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }

        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                $scope.product_categories = httpResult.data;
            });
        }

        function get_missing_title_parents(){
            return datacontext.get_missing_title_parents().then(function(httpResult){
                vm.missing_parents = httpResult.data.data;
            });
        }

        function get_child_cnt_zero_parents(){
            return datacontext.get_child_cnt_zero_parents().then(function(httpResult){
                vm.child_cnt_zero_parents = httpResult.data.data;
            });
        }

        function get_color_variation_issue_parents(){
            return datacontext.get_color_variation_issue_parents().then(function(httpResult){
                vm.color_variation_issue_parents = httpResult.data.data;
            });
        }

        function get_aws_variation_themes() {
            return datacontext.get_aws_variation_themes().then(function(httpResult) {
                vm.aws_variation_themes = httpResult.data.data;
            });
        }

        $scope.refresh_parent_rollup_cnt = function (){
            datacontext.update_product_rollup_count().then(function (httpResult) {
                if (httpResult.data.success === true) {
                    log_success("parent rollup count updated");
                } else {
                    log_success("parent rollup count not updated");
                }
                get_product_parent();
            });
        };

        function get_product_parent() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // initial page size
            },{
                getData: function(params) {
                    vm.query.page = params.page;
                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_product_parent(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';
    var controllerId = 'parentDetailCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$window', '$modal','$routeParams', parentDetailCtrl]);

    function parentDetailCtrl(common, datacontext, $scope, $window, $modal, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');

        var vm = this;
        vm.parent = [];
        $scope.parent_id = $routeParams.parent_id;

        // setting for audit log
        $scope.audit_link_id = $routeParams.parent_id;
        $scope.audit_type_id = 6;

        vm.title = 'parent Detail View';
        vm.add_spid = '';
        activate();

        function activate() {
            var promises = [
                get_product_parent(),
                get_product_parent_status(),
                get_store_products_for_parent(),
                get_store_products_from_parent({order_by:"IFNULL(sp.aws_variation_2_value, p.aws_variation_2_value), IFNULL(sp.aws_variation_1_value, p.aws_variation_1_value)"}),
                get_duplicate_asin_product_parents()
            ];
            common.activateController(promises, controllerId)
                .then(function() {});
        }

        function get_product_parent() {
            return datacontext.get_product_parent({product_parent_id:$scope.parent_id, get_recent_override:1}).then(function(httpResult) {
                vm.parent = httpResult.data.data[0];
                if(angular.isUndefined(vm.parent)  == true){
                    vm.parent = 0;
                }
                vm.recent_override = httpResult.data.recent_override;
            });
        }

        function get_store_products_for_parent() {
            return datacontext.get_store_products_for_parent({product_parent_id:$scope.parent_id}).then(function(httpResult) {
                vm.parent_spids = httpResult.data.data;
                console.log(vm.parent_spids);
            });
        }
  
        function get_store_products_from_parent() {
            return datacontext.get_store_products_from_parent({parent_id:$scope.parent_id,order_by:"CASE p.is_active_override WHEN 1 THEN 1  WHEN 2 THEN 2 ELSE 3 END,sp.warehouse_id ASC, p.category_id ASC,IFNULL(sp.aws_variation_2_value, p.aws_variation_2_value), IFNULL(sp.aws_variation_1_value, p.aws_variation_1_value)"}).then(function(httpResult) {
                vm.children = httpResult.data.data;
                console.log(httpResult.data);
                $scope.non_multi_spids = httpResult.data.non_multi_spids;
            });
        }

        function get_product_parent_status() {
            return datacontext.get_product_parent_status().then(function(httpResult) {
                vm.parentStatus = httpResult.data.data;
            });
        }

        function get_duplicate_asin_product_parents() {
            return datacontext.get_duplicate_asin_product_parents({product_parent_id:$scope.parent_id}).then(function(httpResult) {
                vm.parent_asin_duplicates = httpResult.data.data;
                console.log(httpResult.data);
                if(httpResult.data.data.length){
                    $scope.duplicate_asin_product_parents = httpResult.data.data[0].parent_list;
                    $scope.duplicate_asin = httpResult.data.data[0].asin;
                    $scope.duplicate_asin_product_parents_list = $scope.duplicate_asin_product_parents.split(',');  
                }
            })
        }

        $scope.create_phantom = function (data) {

            $scope.payload = {
                data: data,
                step: 1
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/amz_phantom_create_modal.html',
                controller: 'createPhantomModalCtrl',
                resolve: {
                    payload: function () {
                        return $scope.payload;
                    }
                }
            }).result.then(function(result){
                activate();
            });

            $scope.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        vm.resendParent = function(data) {
            var payload = {
                product_parent_id: data.product_parent_id,
                parent_status_id: 1,
                parent_data_id:'',
                relationship_status_id:1,
                relationship_data_id:'',
                parent_resend_requested:1
            };

            return datacontext.update_product_parent(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
            });
        };

        vm.auditPass = function(data,status) {
            var payload = {
                product_parent_id: data.product_parent_id,
                audit_notes: data.user_audit_notes,
                audit_status: status
            };

            return datacontext.update_product_parent_audit(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
            });
        };
        vm.color_prefix_update = function(color_prefix,parent_id) {
            var payload = {
                product_parent_id: parent_id,
                color_prefix: color_prefix
            };

            return datacontext.update_product_parent_color_prefix(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
            });
        };
        vm.parent_title_update = function(parent_title,parent_id) {
            var payload = {
                product_parent_id: parent_id,
                parent_title: parent_title
            };

            return datacontext.update_product_parent(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
                log_success("Parent title is updated!");
            });
        };

        vm.custom_bullet_update = function(custom_bullet,parent_id) {
            if (!custom_bullet || !custom_bullet.trim()) {
                    vm.custom_bullet_error = true;
                    return;
                }
            vm.custom_bullet_error = false;

            var payload = {
                product_parent_id: parent_id,
                custom_bullet: custom_bullet
            };

            return datacontext.update_product_parent(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
                log_success("Custom Bullet is updated!");
            });
        };

        vm.parent_theme_update = function(theme, parent_id) {

            if (!theme || !theme.trim()) {
                return;
            }

            var payload = {
                product_parent_id: parent_id,
                theme: theme.trim()
            };

            return datacontext.update_product_parent(payload).then(function(httpResult) {

            if (httpResult.data.success === false) {
                    vm.theme_error = true;
                    vm.theme_error_message = httpResult.data.message;
                    vm.theme_error_parent_id = httpResult.data.message.match(/\d+$/)[0];
                    return;
                }

                vm.theme_error = false;
                vm.theme_error_message = '';

                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
                log_success("Theme is updated!");

            });
        };



        vm.parent_manualctrl_update = function(parent_id,manual_control) {
            var payload = {
                product_parent_id: parent_id,
                manual_control: manual_control
            };

            return datacontext.update_product_parent(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
            });
        };

        vm.parent_override = function(product_parent_id,master_parent_id) {
            var payload = {
                product_parent_id: product_parent_id,
                master_parent_id: master_parent_id
            };

            return datacontext.parent_override(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
            });
        };

        vm.resendRelationship = function(data) {
          console.log(data);
            var payload = {
                product_parent_id: data.product_parent_id,
                relationship_status_id:1,
                relationship_data_id:'',
                relation_resend_requested:1,
                purge_children: data.purge_children
            };

            return datacontext.update_product_parent(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
            });
        };

        vm.resendRelationshipChilds = function(data) {

            console.log(data);
            var payload = {
                product_parent_id: data.product_parent_id,
                relation_resend_requested:1
            }

            return datacontext.resend_parent_relationship_childs(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_product_parent();
            });
        }

        vm.addSPID = function(data) {
          console.log($scope.parent_id);
          console.log(data);
          var payload = {
              product_parent_id: $scope.parent_id,
              spid: data
          };
            return datacontext.add_spid_product_parent(payload).then(function(httpResult) {
                // refresh
                $scope.$broadcast('refreshAuditLog', 'refresh');
                get_store_products_from_parent({order_by:"IFNULL(sp.aws_variation_2_value, p.aws_variation_2_value), IFNULL(sp.aws_variation_1_value, p.aws_variation_1_value)"});
            });
        };
        $scope.editParent = function (product_parent_id,store_id,aws_variation_theme_id) {
          //console.log("$routeParams",$routeParams);
          console.log("product_parent_id",product_parent_id);
          $scope.product_parent_id = product_parent_id;
          $scope.store_id = store_id;
          $scope.aws_variation_theme_id = aws_variation_theme_id;
          console.log("store_id",$scope.store_id);
          console.log("aws_variation_theme_id",$scope.aws_variation_theme_id);
          //product_id = $scope.product_id;
         var modalInstance = $modal.open({
             templateUrl: '/app/products/partials/edit_parent.html',
             controller: 'editParentctrl',
             scope: $scope,
             windowClass: 'small',
             resolve: {
              items: function () {
                return $scope.product_parent_id;
              }
            }
         }).result.then(function (result) {

         });

         vm.cancel = function () {
             modalInstance.dismiss('cancel');
         };
      };

        vm.mwsFullLookup = function(data) {
            var payload = {
                asin: data.store_sku,
                store_product_id: data.store_product_id
            };
            return datacontext.mwsFullLookup(payload).then(function(httpResult) {
                // refresh
                if ( httpResult.result ) {
                	get_store_products_from_parent({order_by:"IFNULL(sp.aws_variation_2_value, p.aws_variation_2_value), IFNULL(sp.aws_variation_1_value, p.aws_variation_1_value)"});
                } else  {
                    // failure
                    log('asin not found on amazon');
                }

            });
        };
        vm.showconfirmbox = function (data) {
          if ($window.confirm("Are you sure you want to Delete?")){
              vm.removeParent(data);
          } else{
              console.log("we are good");
          }

        }

        vm.removeParent = function(data) {
            var payload = {
                product_parent_id: data
            };
            console.log(payload);
            return datacontext.remove_parent(payload).then(function(httpResult) {
              $scope.$broadcast('refreshAuditLog', 'refresh');
              get_product_parent();
              get_store_products_from_parent({order_by:"IFNULL(sp.aws_variation_2_value, p.aws_variation_2_value), IFNULL(sp.aws_variation_1_value, p.aws_variation_1_value)"});
            });
        };

        vm.showconfirmboxchild = function (data) {
          if ($window.confirm("Are you sure you want to remove Child?")){
              vm.removeChild(data);
          } else{
              console.log("we are good");
          }

        }
        vm.removeChild = function(data) {
            var payload = {
                parent_id: '',
                store_product_id: data.store_product_id
            };
            return datacontext.update_store_product(payload).then(function(httpResult) {
                // refresh
                //todo add audit
            	//get_store_products_from_parent({order_by:"IFNULL(sp.aws_variation_2_value, p.aws_variation_2_value), IFNULL(sp.aws_variation_1_value, p.aws_variation_1_value)"});
            });
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'editParentctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance',  editParentctrl]);

    function editParentctrl(common, datacontext, $scope, $modalInstance) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        // Pushes input to scope
        console.log("product_id",$scope.product_id);

        //$scope.product_id = 0;
        $scope.ok = function (product_parent_id,store_id,aws_variation_theme_id) {
          console.log("store_id",store_id);
          console.log("aws_variation_theme_id",aws_variation_theme_id);
          console.log("product_id",product_parent_id);
          var payload = {
              product_parent_id: product_parent_id,
              store_id: store_id,
              aws_variation_theme_id: aws_variation_theme_id
          };
          return datacontext.update_product_parent(payload).then(function (httpResult) {

              $modalInstance.close();
              get_product_parent();
          });

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }

    function get_product_parent() {
      var vm = this;

        vm.tableParams = new NgTableParams({
            count: vm.query.limit // initial page size
        },{
            getData: function(params) {
                vm.query.page = params.page;
                for(var key in params.sorting()) {
                    vm.query.order_by = key;
                    vm.query.order_dir = params.sorting()[key];
                }
                // ajax request to api
                return datacontext.get_product_parent(vm.query).then(function (httpResult) {
                    params.total(httpResult.data.total);
                    vm.results_total = httpResult.data.total;
                    // set new data
                    vm.results = httpResult.data.data;
                    vm.grid = 1;
                    return httpResult.data.data;
                });
            }
        });
    }
})();
